import {useContext, useState} from "react";
import TextInputWeex from "../../elements/TextInputWeex";
import NumberInputWeex from "../../elements/NumberInputWeex";
import SelectWeex from "../../elements/SelectWeex";
import LabelWeex from "../../elements/LabelWeex";
import {ElementStyles} from "../../elements/ElementStyles";
import {APIContext} from "../../Globals.tsx";
import AutoTextInputWeex from "../../elements/AutoTextInputWeex";

function checkValid(tags, tagsOptions, scoreType){
  return tags.includes(tagsOptions.filter(t => t.label === "Benchmark")[0].value) && (scoreType !== 0 && scoreType !== 1 && scoreType !== 5);
}

export default function AddComponentContent({
                                              addComponent,
                                              tagsOptions,
                                              setTagsOptions,
                                              editValue,
                                              viewComponent = false,
                                              ...props
                                            }){
  const scoreStyles = [{label: "Reps", value: 0}, {label: "Time", value: 1}, {
    label: "Time + Reps",
    value: 2
  }, {label: "Rds. + Reps", value: 3}, {label: "Weight", value: 4}, {label: "Weight + Reps", value: 5}, {
    label: "None",
    value: -1
  }];
  const [scoreType, setScoreType] = useState(editValue ? editValue.scoreType : -1);
  const [name, setName] = useState(editValue ? editValue.name : "");
  const [description, setDescription] = useState(editValue ? editValue.description : "");
  const [rounds, setRounds] = useState(editValue ? editValue.rounds : 1);
  const [timecap, setTimecap] = useState(editValue ? editValue.timecap : 0);
  const [note, setNote] = useState(editValue ? editValue.note : "");
  const [tags, setTags] = useState(editValue ? editValue.tags : []);
  const [newTag, setNewTag] = useState("");
  const {addTag} = useContext(APIContext);

  const styles = {
    container: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: "var(--background)",
      color: ElementStyles.color2,
      minHeight: ElementStyles.height,
      alignItems: "center",
      textWrap: "noWrap"
    },
    labels: {background: "transparent", color: ElementStyles.color}
  };

  function save(edit = false){
    addComponent({
      id: edit ? (editValue?.id) : undefined,
      scoreType: scoreType < 0 ? null : scoreType,
      name,
      description,
      rounds,
      timecap,
      note,
      tags,
      edit: viewComponent ? false : edit
    });
  }

  function createTag(){
    if(newTag.length){
      addTag(newTag).then((ans) => {
        setTagsOptions(ans);
        setTags((tags) =>
          [...tags, ans?.tags.find((tag) => tag.name === newTag.trim())?.id]
        );
        setNewTag("");
      });
    }
  }

  return (<div style={styles.container} {...props}>
    <TextInputWeex placeholder={"Name"} onChange={(e) => setName(e.target.value)} value={name} label={"Name"}/>
    <br/>
    <AutoTextInputWeex placeholder={"Beschreibung"} rows={15} onChange={(e) => setDescription(e.target.value)}
                       value={description} label={"Beschreibung"}/>
    <br/>
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      flexDirection: window.innerWidth < 1660 ? "column" : "row"
    }}>
      <div style={{display: "flex"}}>
        <NumberInputWeex onChange={(e) => setRounds(e)} value={rounds} label={"Runden"}/>
      </div>
      <br/>
      <div style={{display: "flex"}}>
        <TextInputWeex placeholder={"Timer"} onChange={(e) => setTimecap(e.target.value)} value={timecap}
                       label={"Cap"}/>
        <LabelWeex style={styles.labels}>min</LabelWeex>
      </div>
    </div>
    <br/>
    <SelectWeex options={scoreStyles} isMulti={false} isClearable={false} placeholder={"Score Type"}
                valueRaw={scoreType} onChange={(e) => setScoreType(e.value)} label={"Score Type"}/>
    <br/>
    <TextInputWeex placeholder={"Note"} onChange={(e) => setNote(e.target.value)} value={note} label={"Note"}/>
    <br/>
    <SelectWeex options={tagsOptions} isMulti={true} isSearchable={true} placeholder={"Tags"}
                style={{...styles.labels}}
                onChange={(e) => setTags(e?.map(e => e.value))}
                value={tags?.map(e => tagsOptions.find(f => f.value === e))}
                label={"Tags"}
    />
    <br/>
    <div style={{display: "flex", flexDirection: "row", alignItems: "flex-end", gap: "4%"}}>
      <TextInputWeex onChange={(e) => setNewTag(e.target.value)} value={newTag} placeholder={"neuer Tag"}
                     label={"neuer Tag"}/>
      <button className={"secondarybutton"} style={{margin: 0, lineHeight: 0.75}} onClick={createTag}>Tag
        erstellen
      </button>
    </div>
    <br/>
    {checkValid(tags, tagsOptions, scoreType)&&<div style={{color: "red"}}>Benchmark Workouts können nur Reps, Time oder Weight+Reps als Score haben...</div>}
    {editValue && <button className={"secondarybutton"} onClick={() => save(true)}
                          disabled={checkValid(tags, tagsOptions, scoreType)}>Änderung speichern und hinzufügen (Ändert
      bestehende)</button>}
    <button className={"primarybutton"} onClick={() => save(false)} style={{marginTop: 5}}
            disabled={checkValid(tags, tagsOptions, scoreType)}>{editValue && "Als neue Komponente "}{viewComponent ? " speichern und hinzufügen" : "Speichern und hinzufügen"}</button>
  </div>);
}